module.exports = __webpack_public_path__ + "img/network.a9f0c80.png";